@if (incomeTaxEntity$ | async;) {
  <form [formGroup]="formGroup">
    @if(periodiekeGiften.length > 0) {
        <div formArrayName="periodiekeGiften">
          @for(item of periodiekeGiften.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control formControlName="omschrijving"
                                              id="omschrijving"
                                              [label]="i === 0 ? 'Omschrijving periodieke gift' : ''"
                                              class="col-auto custom-input-250"

              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Culture ANBI?' : ''"
                                                formControlName="cultureleAnbi"
                                                id="cultureleAnbiPer"
                                                [options]="optionsJaNee"
                                                class="col-auto custom-input-150"
                                                [required]=true
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-text-form-control formControlName="transactienummer"
                                              id="transactienummer"
                                              [label]="i === 0 ? 'Transactienummer' : ''"
                                              class="col-auto custom-input-150"
                                              align="right"
                                              [required]=true
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-bsn-form-control formControlName="rsin"
                                             id="rsin"
                                             [label]="i === 0 ? 'RSIN' : ''"
                                             class="col-auto custom-input-150"
                                             [required]=true
              >
              </snelstart-ui-bsn-form-control>
              <snelstart-ui-number-form-control formControlName="bedrag"
                                                id="bedrag"
                                                [label]="i === 0 ? 'Bedrag' : ''"
                                                class="col-auto custom-input-150"
                                                [decimals]="0"
                                                align="right"
                                                prefix="€"
                                                [required]=true
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button id="buttonDeleteKosten"
                                   type="secondary"
                                   size="medium"
                                   icon="trash"
                                   (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
              >
              </snelstart-ui-button>
            </div>
          }
        </div>
    }
  </form>

}

    <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                         (click)="addRij()">Periodieke gift toevoegen
    </snelstart-ui-button>
